import React, { Component, PropTypes } from 'react';
import AsyncInfiniteList from './AsyncInfiniteList';
import { columnWidth } from 'utils/async-list';
import { Column } from 'react-virtualized';
import { List, Set } from 'immutable';

class CheckboxInfiniteList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      all: props.all,
      loaded: props.entities,
      selected: Set(),
    };

    this._selectOne = this._selectOne.bind(this);
    this._selectAll = this._selectAll.bind(this);
    this._onItemsLoaded = this._onItemsLoaded.bind(this);
    this._renderCheckboxHeader = this._renderCheckboxHeader.bind(this);
    this._renderCheckboxCell = this._renderCheckboxCell.bind(this);
    this._renderSelectableColumns = this._renderSelectableColumns.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      ...this.state,
      all: nextProps.all,
    });
  }

  _selectOne(id) {
    const { selected, all, allItems, loaded } = this.state;
    // const { entities } = this.props;

    let newSelected = selected;
    if (selected.has(id)) {
      newSelected = selected.delete(id);
    } else if (!all) {
      newSelected = selected.add(id);
    }

    let newAll;
    if (all) {
      newAll = !all;
    } else if (allItems) {
      newAll = newSelected.size === allItems.size;
    } else {
      newAll = newSelected.size === loaded.length;
    }

    this.setState(
      {
        ...this.state,
        all: newAll,
        selected: newSelected,
      },
      () => this._notifySelectionChanged(newSelected)
    );
  }

  _selectAll() {
    const { all, allItems, loaded } = this.state;
    const { total } = this.props;

    if (!all) {
      //  Dot not refesh if already done once
      if (allItems && allItems.size !== total) {
        this.props.onAllSelected();
      } else {
        const newSelected = Set(
          loaded.filter(item => !item.error_count).map(i => i.id)
        );

        this.setState(
          {
            ...this.state,
            all: true,
            selected: newSelected,
          },
          () => this._notifySelectionChanged(newSelected)
        );
      }
    } else {
      this._notifySelectionChanged(Set());

      this.setState({
        ...this.state,
        all: false,
        selected: Set(),
      });
    }
  }

  _renderCheckboxHeader() {
    const { all } = this.state;

    return (
      <div className="ui checkbox" onClick={this._selectAll}>
        <input
          type="checkbox"
          className="hidden"
          checked={all}
          onChange={this._selectAll}
        />
        <label />
      </div>
    );
  }

  _renderCheckboxCell({ rowData }) {
    const { all } = this.state;
    const { selected } = this.state;
    const { id } = rowData;

    const checked = all || selected.has(id);
    const check = evt => {
      evt.stopPropagation();
      this._selectOne(id);
    };

    const translate = 'translate(-50%, -50%)';
    const checkboxStyles = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: translate,
      WebkitTransform: translate,
    };

    const renderCell = (
      <div
        style={{ width: '100%', height: '57px', position: 'relative' }}
        onClick={check}
      >
        <div className="ui checkbox" style={checkboxStyles}>
          <input
            type="checkbox"
            className="hidden"
            checked={checked}
            onChange={check}
          />
          <label />
        </div>
      </div>
    );

    const renderError = <div />;

    return rowData && rowData.error_count ? renderError : renderCell;
  }

  _renderSelectableColumns(width) {
    const { renderColumns } = this.props;

    const columns = renderColumns(width);

    // Adding selection column
    columns.unshift(
      <Column
        key="selected"
        dataKey="selected"
        width={columnWidth(width, 1)}
        disableSort
        headerClassName="center aligned"
        className="center aligned"
        headerRenderer={this._renderCheckboxHeader}
        cellRenderer={this._renderCheckboxCell}
      />
    );

    return columns;
  }

  _onItemsLoaded(items) {
    const { all } = this.state;
    if (all) {
      const ids = items.map(i => i.id);

      this._notifySelectionChanged(ids);

      this.setState({
        ...this.state,
        allItems: items,
        selected: Set(ids),
      });
    }
    this.setState({
      ...this.state,
      loaded: items.toArray(),
    });
  }

  _notifySelectionChanged(selected) {
    const { onSelectionChanged } = this.props;
    onSelectionChanged(selected.size, selected.toArray());
  }

  render() {
    const { total, entities, customRowRenderer, ...rest } = this.props;

    return (
      <AsyncInfiniteList
        initialData={List(entities)}
        totalCount={total}
        rowHeight={58}
        onItemsLoaded={this._onItemsLoaded}
        customRowRenderer={customRowRenderer}
        {...rest}
        renderColumns={this._renderSelectableColumns}
      />
    );
  }
}

CheckboxInfiniteList.propTypes = {
  entities: PropTypes.array.isRequired,
  total: PropTypes.number.isRequired,
  all: PropTypes.bool,
  renderColumns: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onSelectionChanged: PropTypes.func.isRequired,
  onAllSelected: PropTypes.func.isRequired,
  customRowRenderer: PropTypes.func,
};

export default CheckboxInfiniteList;



// WEBPACK FOOTER //
// ./src/modules/common/components/CheckboxInfiniteList.js